import { Link } from "react-router-dom";

type Props = {
  eyebrow?: string;
  title: string;
  desc?: string;
  actionText?: string;
  actionTo?: string;
};

export default function SectionHeading({ eyebrow, title, desc, actionText, actionTo }: Props) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="mb-2.5 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold tracking-wide text-accent-900">
            <i className="ri-fire-line text-sm"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-2.5 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {actionText && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
        >
          {actionText}
          <i className="ri-arrow-right-line text-base"></i>
        </Link>
      )}
    </div>
  );
}